// Components
import BlurImage from '@/components/shared/blur-image'

// Utils
import { cn, placeholderBlurhash } from '@/lib/utils'

// Types
import type { Locale } from '@/i18n-config'

export function HomeLandingText({ lang }: { lang: Locale }) {
  return (
    <div>
      <div className="max-w-5xl px-4 text-center">
        <BlurImage
          src="/assets/images/home/landing-text.png"
          alt="Landing image"
          width={1200}
          height={269}
          priority={true}
          placeholder="blur"
          className="pointer-events-none size-full object-contain"
          blurDataURL={placeholderBlurhash}
        />
        <h1 className="sr-only">
          Çalışkan restorasyon yapı inşaat sanayi ticaret a.ş.
        </h1>
      </div>
    </div>
  )
}
